













































































































































































































































































































































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskPhone } from '@/utils/common'
import EventBus from '@/plugins/EventBus'
import moment from 'moment'
import { useMedicos } from '@/composables'

@Component

export default class ComponenteBackofficePaciente extends Vue {
  @Prop({ default: false }) active: boolean
  $refs!: { medicoHisIdForm: any, medicoHisId: HTMLInputElement }
  loadBuscarMedico: boolean = false
  loadResolverPendenciaMedico: boolean = false
  dialogMedico: boolean = false
  loadingSaveExecutantDoctorModal: boolean = false
  executantDoctorId: string = ''
  executantDoctorModalStep: 1 | 2 = 1

  get dialogMedicoHisId() { return this.dialogMedico }
  set dialogMedicoHisId(value: boolean) { this.dialogMedico = value }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get executantDoctors() {
    return useMedicos.medicosByCurrentUser
  }

  loadDoctors() {
    useMedicos.loadMedicosByCurrentUser()
  }

  get executantDoctorModal() {
    return this.getBackofficeGlobalStore.executantDoctorModal
  }

  get loadingBuscarMedico() { return this.loadBuscarMedico }
  set loadingBuscarMedico(value: boolean) { this.loadBuscarMedico = value }

  get loadingResolverPendenciaMedico() { return this.loadResolverPendenciaMedico }
  set loadingResolverPendenciaMedico(value: boolean) { this.loadResolverPendenciaMedico = value }

  get medicoDoHis() { return this.getBackofficeGlobalStore.medicoDoHis }

  async saveExecutantDoctor() {
    try {
      this.loadingSaveExecutantDoctorModal = true
      const surgerySolicitationId = this.getBackofficeGlobalStore.solicitacao.id

      const APIRequest = await this.getBackofficeGlobalStore.updateExecutantDoctor({ executantDoctorId: this.executantDoctorId, surgerySolicitationId })

      if (APIRequest.success) {
        await this.getBackofficeGlobalStore.getSolicitacaoById(surgerySolicitationId)

        EventBus.$emit('setSnackbar', { show: true, text: 'Ação concluída com sucesso', icon: 'done', color: '#2E7D32' })
        this.executantDoctorModalStep = 1
        this.getBackofficeGlobalStore.setExecutantDoctorModal(false)
        this.executantDoctorId = ''
      } else {
        EventBus.$emit('setSnackbar', { show: true, text: APIRequest.message || 'Não foi possível concluir a ação', icon: 'warning', color: '#C62828' })
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Não foi possível concluir a ação', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingSaveExecutantDoctorModal = false
      this.executantDoctorModalStep = 1
    }
  }

  moveExecutantDoctorModalToStep2() {
    if (!this.executantDoctorId) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Selecione um médico', icon: 'warning', color: '#C62828' })
    } else {
      this.executantDoctorModalStep = 2
    }
  }

  cancelExecutantDoctorOperation() {
    this.executantDoctorId = ''
    this.getBackofficeGlobalStore.setExecutantDoctorModal(false)
    this.executantDoctorModalStep = 1
  }

  async getMedicoDoHisById() {
    this.loadingBuscarMedico = true
    const request = await this.getBackofficeGlobalStore.getMedicoDoHisById()
    if (!request.success) EventBus.$emit('setSnackbar', { show: true, text: request.message || 'Ocorreu um erro na requisição. Entre em contato com o suporte', icon: 'warning', color: '#C62828', timeout: 6000 })
    this.loadingBuscarMedico = false
  }

  async backofficeAgendamentoResolvePendenciaMedico() {
    this.loadingResolverPendenciaMedico = true
    const response = await this.getBackofficeGlobalStore.backofficeAgendamentoResolvePendenciaMedico()
    if (response.success) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Pendência de médico com sucesso!', icon: 'done', color: '#2E7D32' })
      this.getBackofficeGlobalStore.solicitacao.temPendenciaDeMedico = false
      this.dialogMedicoHisId = false
      this.getBackofficeGlobalStore.clearMedicoDoHis()
    } else {
      EventBus.$emit('setSnackbar', {
        show: true,
        text: response.message || 'Ocorreu um erro na requisição.',
        icon: 'warning',
        color: '#C62828',
        timeout: 6000,
      })
    }
    this.loadingResolverPendenciaMedico = false
  }

  campoHabilitado(prop: string) {
    if (this.getBackofficeGlobalStore.template.formulario) {
      const response = this.getBackofficeGlobalStore.template.formulario[prop]

      if (response) return response.habilitado
    }

    return false
  }

  maskPhoneUtil(value) {
    return maskPhone(value)
  }

  maskDateUtil(value) {
    if (['', null, undefined].includes(value)) return ' - '
    return moment(value).format('DD/MM/YYYY')
  }

  @Watch('dialogMedicoHisId')
  onChangeDialogMedicoHisId(value: boolean) {
    setTimeout(() => {
      if (value) {
        this.$refs.medicoHisId.focus()
      } else {
        this.getBackofficeGlobalStore.clearMedicoDoHis()
      }
    }, 100)
  }
}
